var map = {
	"./": 31,
	"./_lib/buildFormatLongFn": 29,
	"./_lib/buildFormatLongFn/": 29,
	"./_lib/buildFormatLongFn/index": 29,
	"./_lib/buildFormatLongFn/index.js": 29,
	"./_lib/buildLocalizeFn": 34,
	"./_lib/buildLocalizeFn/": 34,
	"./_lib/buildLocalizeFn/index": 34,
	"./_lib/buildLocalizeFn/index.js": 34,
	"./_lib/buildMatchFn": 36,
	"./_lib/buildMatchFn/": 36,
	"./_lib/buildMatchFn/index": 36,
	"./_lib/buildMatchFn/index.js": 36,
	"./_lib/buildMatchPatternFn": 35,
	"./_lib/buildMatchPatternFn/": 35,
	"./_lib/buildMatchPatternFn/index": 35,
	"./_lib/buildMatchPatternFn/index.js": 35,
	"./af": 619,
	"./af/": 619,
	"./af/_lib/formatDistance": 276,
	"./af/_lib/formatDistance/": 276,
	"./af/_lib/formatDistance/index": 276,
	"./af/_lib/formatDistance/index.js": 276,
	"./af/_lib/formatLong": 277,
	"./af/_lib/formatLong/": 277,
	"./af/_lib/formatLong/index": 277,
	"./af/_lib/formatLong/index.js": 277,
	"./af/_lib/formatRelative": 278,
	"./af/_lib/formatRelative/": 278,
	"./af/_lib/formatRelative/index": 278,
	"./af/_lib/formatRelative/index.js": 278,
	"./af/_lib/localize": 279,
	"./af/_lib/localize/": 279,
	"./af/_lib/localize/index": 279,
	"./af/_lib/localize/index.js": 279,
	"./af/_lib/match": 280,
	"./af/_lib/match/": 280,
	"./af/_lib/match/index": 280,
	"./af/_lib/match/index.js": 280,
	"./af/index": 795,
	"./af/index.d.ts": 1078,
	"./af/index.js": 795,
	"./af/index.js.flow": 1079,
	"./af/package": 895,
	"./af/package.json": 895,
	"./ar-DZ": 620,
	"./ar-DZ/": 620,
	"./ar-DZ/_lib/formatDistance": 281,
	"./ar-DZ/_lib/formatDistance/": 281,
	"./ar-DZ/_lib/formatDistance/index": 281,
	"./ar-DZ/_lib/formatDistance/index.js": 281,
	"./ar-DZ/_lib/formatLong": 282,
	"./ar-DZ/_lib/formatLong/": 282,
	"./ar-DZ/_lib/formatLong/index": 282,
	"./ar-DZ/_lib/formatLong/index.js": 282,
	"./ar-DZ/_lib/formatRelative": 283,
	"./ar-DZ/_lib/formatRelative/": 283,
	"./ar-DZ/_lib/formatRelative/index": 283,
	"./ar-DZ/_lib/formatRelative/index.js": 283,
	"./ar-DZ/_lib/localize": 284,
	"./ar-DZ/_lib/localize/": 284,
	"./ar-DZ/_lib/localize/index": 284,
	"./ar-DZ/_lib/localize/index.js": 284,
	"./ar-DZ/_lib/match": 285,
	"./ar-DZ/_lib/match/": 285,
	"./ar-DZ/_lib/match/index": 285,
	"./ar-DZ/_lib/match/index.js": 285,
	"./ar-DZ/index": 796,
	"./ar-DZ/index.d.ts": 1080,
	"./ar-DZ/index.js": 796,
	"./ar-DZ/index.js.flow": 1081,
	"./ar-DZ/package": 896,
	"./ar-DZ/package.json": 896,
	"./ar-MA": 621,
	"./ar-MA/": 621,
	"./ar-MA/_lib/formatDistance": 286,
	"./ar-MA/_lib/formatDistance/": 286,
	"./ar-MA/_lib/formatDistance/index": 286,
	"./ar-MA/_lib/formatDistance/index.js": 286,
	"./ar-MA/_lib/formatLong": 287,
	"./ar-MA/_lib/formatLong/": 287,
	"./ar-MA/_lib/formatLong/index": 287,
	"./ar-MA/_lib/formatLong/index.js": 287,
	"./ar-MA/_lib/formatRelative": 288,
	"./ar-MA/_lib/formatRelative/": 288,
	"./ar-MA/_lib/formatRelative/index": 288,
	"./ar-MA/_lib/formatRelative/index.js": 288,
	"./ar-MA/_lib/localize": 289,
	"./ar-MA/_lib/localize/": 289,
	"./ar-MA/_lib/localize/index": 289,
	"./ar-MA/_lib/localize/index.js": 289,
	"./ar-MA/_lib/match": 290,
	"./ar-MA/_lib/match/": 290,
	"./ar-MA/_lib/match/index": 290,
	"./ar-MA/_lib/match/index.js": 290,
	"./ar-MA/index": 797,
	"./ar-MA/index.d.ts": 1082,
	"./ar-MA/index.js": 797,
	"./ar-MA/index.js.flow": 1083,
	"./ar-MA/package": 897,
	"./ar-MA/package.json": 897,
	"./ar-SA": 622,
	"./ar-SA/": 622,
	"./ar-SA/_lib/formatDistance": 291,
	"./ar-SA/_lib/formatDistance/": 291,
	"./ar-SA/_lib/formatDistance/index": 291,
	"./ar-SA/_lib/formatDistance/index.js": 291,
	"./ar-SA/_lib/formatLong": 292,
	"./ar-SA/_lib/formatLong/": 292,
	"./ar-SA/_lib/formatLong/index": 292,
	"./ar-SA/_lib/formatLong/index.js": 292,
	"./ar-SA/_lib/formatRelative": 293,
	"./ar-SA/_lib/formatRelative/": 293,
	"./ar-SA/_lib/formatRelative/index": 293,
	"./ar-SA/_lib/formatRelative/index.js": 293,
	"./ar-SA/_lib/localize": 294,
	"./ar-SA/_lib/localize/": 294,
	"./ar-SA/_lib/localize/index": 294,
	"./ar-SA/_lib/localize/index.js": 294,
	"./ar-SA/_lib/match": 295,
	"./ar-SA/_lib/match/": 295,
	"./ar-SA/_lib/match/index": 295,
	"./ar-SA/_lib/match/index.js": 295,
	"./ar-SA/index": 798,
	"./ar-SA/index.d.ts": 1084,
	"./ar-SA/index.js": 798,
	"./ar-SA/index.js.flow": 1085,
	"./ar-SA/package": 898,
	"./ar-SA/package.json": 898,
	"./az": 623,
	"./az/": 623,
	"./az/_lib/formatDistance": 296,
	"./az/_lib/formatDistance/": 296,
	"./az/_lib/formatDistance/index": 296,
	"./az/_lib/formatDistance/index.js": 296,
	"./az/_lib/formatLong": 297,
	"./az/_lib/formatLong/": 297,
	"./az/_lib/formatLong/index": 297,
	"./az/_lib/formatLong/index.js": 297,
	"./az/_lib/formatRelative": 298,
	"./az/_lib/formatRelative/": 298,
	"./az/_lib/formatRelative/index": 298,
	"./az/_lib/formatRelative/index.js": 298,
	"./az/_lib/localize": 299,
	"./az/_lib/localize/": 299,
	"./az/_lib/localize/index": 299,
	"./az/_lib/localize/index.js": 299,
	"./az/_lib/match": 300,
	"./az/_lib/match/": 300,
	"./az/_lib/match/index": 300,
	"./az/_lib/match/index.js": 300,
	"./az/index": 799,
	"./az/index.d.ts": 1086,
	"./az/index.js": 799,
	"./az/index.js.flow": 1087,
	"./az/package": 899,
	"./az/package.json": 899,
	"./be": 624,
	"./be/": 624,
	"./be/_lib/formatDistance": 301,
	"./be/_lib/formatDistance/": 301,
	"./be/_lib/formatDistance/index": 301,
	"./be/_lib/formatDistance/index.js": 301,
	"./be/_lib/formatLong": 302,
	"./be/_lib/formatLong/": 302,
	"./be/_lib/formatLong/index": 302,
	"./be/_lib/formatLong/index.js": 302,
	"./be/_lib/formatRelative": 303,
	"./be/_lib/formatRelative/": 303,
	"./be/_lib/formatRelative/index": 303,
	"./be/_lib/formatRelative/index.js": 303,
	"./be/_lib/localize": 304,
	"./be/_lib/localize/": 304,
	"./be/_lib/localize/index": 304,
	"./be/_lib/localize/index.js": 304,
	"./be/_lib/match": 305,
	"./be/_lib/match/": 305,
	"./be/_lib/match/index": 305,
	"./be/_lib/match/index.js": 305,
	"./be/index": 800,
	"./be/index.d.ts": 1088,
	"./be/index.js": 800,
	"./be/index.js.flow": 1089,
	"./be/package": 900,
	"./be/package.json": 900,
	"./bg": 625,
	"./bg/": 625,
	"./bg/_lib/formatDistance": 306,
	"./bg/_lib/formatDistance/": 306,
	"./bg/_lib/formatDistance/index": 306,
	"./bg/_lib/formatDistance/index.js": 306,
	"./bg/_lib/formatLong": 307,
	"./bg/_lib/formatLong/": 307,
	"./bg/_lib/formatLong/index": 307,
	"./bg/_lib/formatLong/index.js": 307,
	"./bg/_lib/formatRelative": 308,
	"./bg/_lib/formatRelative/": 308,
	"./bg/_lib/formatRelative/index": 308,
	"./bg/_lib/formatRelative/index.js": 308,
	"./bg/_lib/localize": 309,
	"./bg/_lib/localize/": 309,
	"./bg/_lib/localize/index": 309,
	"./bg/_lib/localize/index.js": 309,
	"./bg/_lib/match": 310,
	"./bg/_lib/match/": 310,
	"./bg/_lib/match/index": 310,
	"./bg/_lib/match/index.js": 310,
	"./bg/index": 801,
	"./bg/index.d.ts": 1090,
	"./bg/index.js": 801,
	"./bg/index.js.flow": 1091,
	"./bg/package": 901,
	"./bg/package.json": 901,
	"./bn": 626,
	"./bn/": 626,
	"./bn/_lib/formatDistance": 311,
	"./bn/_lib/formatDistance/": 311,
	"./bn/_lib/formatDistance/index": 311,
	"./bn/_lib/formatDistance/index.js": 311,
	"./bn/_lib/formatLong": 312,
	"./bn/_lib/formatLong/": 312,
	"./bn/_lib/formatLong/index": 312,
	"./bn/_lib/formatLong/index.js": 312,
	"./bn/_lib/formatRelative": 313,
	"./bn/_lib/formatRelative/": 313,
	"./bn/_lib/formatRelative/index": 313,
	"./bn/_lib/formatRelative/index.js": 313,
	"./bn/_lib/localize": 226,
	"./bn/_lib/localize/": 226,
	"./bn/_lib/localize/index": 226,
	"./bn/_lib/localize/index.js": 226,
	"./bn/_lib/match": 314,
	"./bn/_lib/match/": 314,
	"./bn/_lib/match/index": 314,
	"./bn/_lib/match/index.js": 314,
	"./bn/index": 802,
	"./bn/index.d.ts": 1092,
	"./bn/index.js": 802,
	"./bn/index.js.flow": 1093,
	"./bn/package": 902,
	"./bn/package.json": 902,
	"./ca": 627,
	"./ca/": 627,
	"./ca/_lib/formatDistance": 315,
	"./ca/_lib/formatDistance/": 315,
	"./ca/_lib/formatDistance/index": 315,
	"./ca/_lib/formatDistance/index.js": 315,
	"./ca/_lib/formatLong": 316,
	"./ca/_lib/formatLong/": 316,
	"./ca/_lib/formatLong/index": 316,
	"./ca/_lib/formatLong/index.js": 316,
	"./ca/_lib/formatRelative": 317,
	"./ca/_lib/formatRelative/": 317,
	"./ca/_lib/formatRelative/index": 317,
	"./ca/_lib/formatRelative/index.js": 317,
	"./ca/_lib/localize": 318,
	"./ca/_lib/localize/": 318,
	"./ca/_lib/localize/index": 318,
	"./ca/_lib/localize/index.js": 318,
	"./ca/_lib/match": 319,
	"./ca/_lib/match/": 319,
	"./ca/_lib/match/index": 319,
	"./ca/_lib/match/index.js": 319,
	"./ca/index": 803,
	"./ca/index.d.ts": 1094,
	"./ca/index.js": 803,
	"./ca/index.js.flow": 1095,
	"./ca/package": 903,
	"./ca/package.json": 903,
	"./cs": 628,
	"./cs/": 628,
	"./cs/_lib/formatDistance": 320,
	"./cs/_lib/formatDistance/": 320,
	"./cs/_lib/formatDistance/index": 320,
	"./cs/_lib/formatDistance/index.js": 320,
	"./cs/_lib/formatLong": 321,
	"./cs/_lib/formatLong/": 321,
	"./cs/_lib/formatLong/index": 321,
	"./cs/_lib/formatLong/index.js": 321,
	"./cs/_lib/formatRelative": 322,
	"./cs/_lib/formatRelative/": 322,
	"./cs/_lib/formatRelative/index": 322,
	"./cs/_lib/formatRelative/index.js": 322,
	"./cs/_lib/localize": 323,
	"./cs/_lib/localize/": 323,
	"./cs/_lib/localize/index": 323,
	"./cs/_lib/localize/index.js": 323,
	"./cs/_lib/match": 324,
	"./cs/_lib/match/": 324,
	"./cs/_lib/match/index": 324,
	"./cs/_lib/match/index.js": 324,
	"./cs/index": 804,
	"./cs/index.d.ts": 1096,
	"./cs/index.js": 804,
	"./cs/index.js.flow": 1097,
	"./cs/package": 904,
	"./cs/package.json": 904,
	"./cy": 629,
	"./cy/": 629,
	"./cy/_lib/formatDistance": 325,
	"./cy/_lib/formatDistance/": 325,
	"./cy/_lib/formatDistance/index": 325,
	"./cy/_lib/formatDistance/index.js": 325,
	"./cy/_lib/formatLong": 326,
	"./cy/_lib/formatLong/": 326,
	"./cy/_lib/formatLong/index": 326,
	"./cy/_lib/formatLong/index.js": 326,
	"./cy/_lib/formatRelative": 327,
	"./cy/_lib/formatRelative/": 327,
	"./cy/_lib/formatRelative/index": 327,
	"./cy/_lib/formatRelative/index.js": 327,
	"./cy/_lib/localize": 328,
	"./cy/_lib/localize/": 328,
	"./cy/_lib/localize/index": 328,
	"./cy/_lib/localize/index.js": 328,
	"./cy/_lib/match": 329,
	"./cy/_lib/match/": 329,
	"./cy/_lib/match/index": 329,
	"./cy/_lib/match/index.js": 329,
	"./cy/index": 805,
	"./cy/index.d.ts": 1098,
	"./cy/index.js": 805,
	"./cy/index.js.flow": 1099,
	"./cy/package": 905,
	"./cy/package.json": 905,
	"./da": 630,
	"./da/": 630,
	"./da/_lib/formatDistance": 330,
	"./da/_lib/formatDistance/": 330,
	"./da/_lib/formatDistance/index": 330,
	"./da/_lib/formatDistance/index.js": 330,
	"./da/_lib/formatLong": 331,
	"./da/_lib/formatLong/": 331,
	"./da/_lib/formatLong/index": 331,
	"./da/_lib/formatLong/index.js": 331,
	"./da/_lib/formatRelative": 332,
	"./da/_lib/formatRelative/": 332,
	"./da/_lib/formatRelative/index": 332,
	"./da/_lib/formatRelative/index.js": 332,
	"./da/_lib/localize": 333,
	"./da/_lib/localize/": 333,
	"./da/_lib/localize/index": 333,
	"./da/_lib/localize/index.js": 333,
	"./da/_lib/match": 334,
	"./da/_lib/match/": 334,
	"./da/_lib/match/index": 334,
	"./da/_lib/match/index.js": 334,
	"./da/index": 806,
	"./da/index.d.ts": 1100,
	"./da/index.js": 806,
	"./da/index.js.flow": 1101,
	"./da/package": 906,
	"./da/package.json": 906,
	"./de": 631,
	"./de/": 631,
	"./de/_lib/formatDistance": 335,
	"./de/_lib/formatDistance/": 335,
	"./de/_lib/formatDistance/index": 335,
	"./de/_lib/formatDistance/index.js": 335,
	"./de/_lib/formatLong": 336,
	"./de/_lib/formatLong/": 336,
	"./de/_lib/formatLong/index": 336,
	"./de/_lib/formatLong/index.js": 336,
	"./de/_lib/formatRelative": 337,
	"./de/_lib/formatRelative/": 337,
	"./de/_lib/formatRelative/index": 337,
	"./de/_lib/formatRelative/index.js": 337,
	"./de/_lib/localize": 338,
	"./de/_lib/localize/": 338,
	"./de/_lib/localize/index": 338,
	"./de/_lib/localize/index.js": 338,
	"./de/_lib/match": 339,
	"./de/_lib/match/": 339,
	"./de/_lib/match/index": 339,
	"./de/_lib/match/index.js": 339,
	"./de/index": 807,
	"./de/index.d.ts": 1102,
	"./de/index.js": 807,
	"./de/index.js.flow": 1103,
	"./de/package": 907,
	"./de/package.json": 907,
	"./el": 632,
	"./el/": 632,
	"./el/_lib/formatDistance": 340,
	"./el/_lib/formatDistance/": 340,
	"./el/_lib/formatDistance/index": 340,
	"./el/_lib/formatDistance/index.js": 340,
	"./el/_lib/formatLong": 341,
	"./el/_lib/formatLong/": 341,
	"./el/_lib/formatLong/index": 341,
	"./el/_lib/formatLong/index.js": 341,
	"./el/_lib/formatRelative": 342,
	"./el/_lib/formatRelative/": 342,
	"./el/_lib/formatRelative/index": 342,
	"./el/_lib/formatRelative/index.js": 342,
	"./el/_lib/localize": 343,
	"./el/_lib/localize/": 343,
	"./el/_lib/localize/index": 343,
	"./el/_lib/localize/index.js": 343,
	"./el/_lib/match": 344,
	"./el/_lib/match/": 344,
	"./el/_lib/match/index": 344,
	"./el/_lib/match/index.js": 344,
	"./el/index": 808,
	"./el/index.d.ts": 1104,
	"./el/index.js": 808,
	"./el/index.js.flow": 1105,
	"./el/package": 908,
	"./el/package.json": 908,
	"./en-AU": 687,
	"./en-AU/": 687,
	"./en-AU/_lib/formatLong": 345,
	"./en-AU/_lib/formatLong/": 345,
	"./en-AU/_lib/formatLong/index": 345,
	"./en-AU/_lib/formatLong/index.js": 345,
	"./en-AU/index": 809,
	"./en-AU/index.d.ts": 1106,
	"./en-AU/index.js": 809,
	"./en-AU/index.js.flow": 1107,
	"./en-AU/package": 909,
	"./en-AU/package.json": 909,
	"./en-CA": 686,
	"./en-CA/": 686,
	"./en-CA/_lib/formatDistance": 346,
	"./en-CA/_lib/formatDistance/": 346,
	"./en-CA/_lib/formatDistance/index": 346,
	"./en-CA/_lib/formatDistance/index.js": 346,
	"./en-CA/_lib/formatLong": 347,
	"./en-CA/_lib/formatLong/": 347,
	"./en-CA/_lib/formatLong/index": 347,
	"./en-CA/_lib/formatLong/index.js": 347,
	"./en-CA/index": 810,
	"./en-CA/index.d.ts": 1108,
	"./en-CA/index.js": 810,
	"./en-CA/index.js.flow": 1109,
	"./en-CA/package": 910,
	"./en-CA/package.json": 910,
	"./en-GB": 688,
	"./en-GB/": 688,
	"./en-GB/_lib/formatLong": 348,
	"./en-GB/_lib/formatLong/": 348,
	"./en-GB/_lib/formatLong/index": 348,
	"./en-GB/_lib/formatLong/index.js": 348,
	"./en-GB/index": 811,
	"./en-GB/index.d.ts": 1110,
	"./en-GB/index.js": 811,
	"./en-GB/index.js.flow": 1111,
	"./en-GB/package": 911,
	"./en-GB/package.json": 911,
	"./en-IN": 689,
	"./en-IN/": 689,
	"./en-IN/_lib/formatLong": 349,
	"./en-IN/_lib/formatLong/": 349,
	"./en-IN/_lib/formatLong/index": 349,
	"./en-IN/_lib/formatLong/index.js": 349,
	"./en-IN/index": 812,
	"./en-IN/index.d.ts": 1112,
	"./en-IN/index.js": 812,
	"./en-IN/index.js.flow": 1113,
	"./en-IN/package": 912,
	"./en-IN/package.json": 912,
	"./en-NZ": 690,
	"./en-NZ/": 690,
	"./en-NZ/_lib/formatLong": 350,
	"./en-NZ/_lib/formatLong/": 350,
	"./en-NZ/_lib/formatLong/index": 350,
	"./en-NZ/_lib/formatLong/index.js": 350,
	"./en-NZ/index": 813,
	"./en-NZ/index.d.ts": 1114,
	"./en-NZ/index.js": 813,
	"./en-NZ/index.js.flow": 1115,
	"./en-NZ/package": 913,
	"./en-NZ/package.json": 913,
	"./en-US": 205,
	"./en-US/": 205,
	"./en-US/_lib/formatDistance": 163,
	"./en-US/_lib/formatDistance/": 163,
	"./en-US/_lib/formatDistance/index": 163,
	"./en-US/_lib/formatDistance/index.js": 163,
	"./en-US/_lib/formatLong": 275,
	"./en-US/_lib/formatLong/": 275,
	"./en-US/_lib/formatLong/index": 275,
	"./en-US/_lib/formatLong/index.js": 275,
	"./en-US/_lib/formatRelative": 147,
	"./en-US/_lib/formatRelative/": 147,
	"./en-US/_lib/formatRelative/index": 147,
	"./en-US/_lib/formatRelative/index.js": 147,
	"./en-US/_lib/localize": 148,
	"./en-US/_lib/localize/": 148,
	"./en-US/_lib/localize/index": 148,
	"./en-US/_lib/localize/index.js": 148,
	"./en-US/_lib/match": 149,
	"./en-US/_lib/match/": 149,
	"./en-US/_lib/match/index": 149,
	"./en-US/_lib/match/index.js": 149,
	"./en-US/index": 711,
	"./en-US/index.d.ts": 1116,
	"./en-US/index.js": 711,
	"./en-US/index.js.flow": 1117,
	"./en-US/package": 914,
	"./en-US/package.json": 914,
	"./eo": 633,
	"./eo/": 633,
	"./eo/_lib/formatDistance": 351,
	"./eo/_lib/formatDistance/": 351,
	"./eo/_lib/formatDistance/index": 351,
	"./eo/_lib/formatDistance/index.js": 351,
	"./eo/_lib/formatLong": 352,
	"./eo/_lib/formatLong/": 352,
	"./eo/_lib/formatLong/index": 352,
	"./eo/_lib/formatLong/index.js": 352,
	"./eo/_lib/formatRelative": 353,
	"./eo/_lib/formatRelative/": 353,
	"./eo/_lib/formatRelative/index": 353,
	"./eo/_lib/formatRelative/index.js": 353,
	"./eo/_lib/localize": 354,
	"./eo/_lib/localize/": 354,
	"./eo/_lib/localize/index": 354,
	"./eo/_lib/localize/index.js": 354,
	"./eo/_lib/match": 355,
	"./eo/_lib/match/": 355,
	"./eo/_lib/match/index": 355,
	"./eo/_lib/match/index.js": 355,
	"./eo/index": 814,
	"./eo/index.d.ts": 1118,
	"./eo/index.js": 814,
	"./eo/index.js.flow": 1119,
	"./eo/package": 915,
	"./eo/package.json": 915,
	"./es": 634,
	"./es/": 634,
	"./es/_lib/formatDistance": 356,
	"./es/_lib/formatDistance/": 356,
	"./es/_lib/formatDistance/index": 356,
	"./es/_lib/formatDistance/index.js": 356,
	"./es/_lib/formatLong": 357,
	"./es/_lib/formatLong/": 357,
	"./es/_lib/formatLong/index": 357,
	"./es/_lib/formatLong/index.js": 357,
	"./es/_lib/formatRelative": 358,
	"./es/_lib/formatRelative/": 358,
	"./es/_lib/formatRelative/index": 358,
	"./es/_lib/formatRelative/index.js": 358,
	"./es/_lib/localize": 359,
	"./es/_lib/localize/": 359,
	"./es/_lib/localize/index": 359,
	"./es/_lib/localize/index.js": 359,
	"./es/_lib/match": 360,
	"./es/_lib/match/": 360,
	"./es/_lib/match/index": 360,
	"./es/_lib/match/index.js": 360,
	"./es/index": 815,
	"./es/index.d.ts": 1120,
	"./es/index.js": 815,
	"./es/index.js.flow": 1121,
	"./es/package": 916,
	"./es/package.json": 916,
	"./et": 635,
	"./et/": 635,
	"./et/_lib/formatDistance": 361,
	"./et/_lib/formatDistance/": 361,
	"./et/_lib/formatDistance/index": 361,
	"./et/_lib/formatDistance/index.js": 361,
	"./et/_lib/formatLong": 362,
	"./et/_lib/formatLong/": 362,
	"./et/_lib/formatLong/index": 362,
	"./et/_lib/formatLong/index.js": 362,
	"./et/_lib/formatRelative": 363,
	"./et/_lib/formatRelative/": 363,
	"./et/_lib/formatRelative/index": 363,
	"./et/_lib/formatRelative/index.js": 363,
	"./et/_lib/localize": 364,
	"./et/_lib/localize/": 364,
	"./et/_lib/localize/index": 364,
	"./et/_lib/localize/index.js": 364,
	"./et/_lib/match": 365,
	"./et/_lib/match/": 365,
	"./et/_lib/match/index": 365,
	"./et/_lib/match/index.js": 365,
	"./et/index": 816,
	"./et/index.d.ts": 1122,
	"./et/index.js": 816,
	"./et/index.js.flow": 1123,
	"./et/package": 917,
	"./et/package.json": 917,
	"./eu": 636,
	"./eu/": 636,
	"./eu/_lib/formatDistance": 366,
	"./eu/_lib/formatDistance/": 366,
	"./eu/_lib/formatDistance/index": 366,
	"./eu/_lib/formatDistance/index.js": 366,
	"./eu/_lib/formatLong": 367,
	"./eu/_lib/formatLong/": 367,
	"./eu/_lib/formatLong/index": 367,
	"./eu/_lib/formatLong/index.js": 367,
	"./eu/_lib/formatRelative": 368,
	"./eu/_lib/formatRelative/": 368,
	"./eu/_lib/formatRelative/index": 368,
	"./eu/_lib/formatRelative/index.js": 368,
	"./eu/_lib/localize": 369,
	"./eu/_lib/localize/": 369,
	"./eu/_lib/localize/index": 369,
	"./eu/_lib/localize/index.js": 369,
	"./eu/_lib/match": 370,
	"./eu/_lib/match/": 370,
	"./eu/_lib/match/index": 370,
	"./eu/_lib/match/index.js": 370,
	"./eu/index": 817,
	"./eu/index.d.ts": 1124,
	"./eu/index.js": 817,
	"./eu/index.js.flow": 1125,
	"./eu/package": 918,
	"./eu/package.json": 918,
	"./fa-IR": 637,
	"./fa-IR/": 637,
	"./fa-IR/_lib/formatDistance": 371,
	"./fa-IR/_lib/formatDistance/": 371,
	"./fa-IR/_lib/formatDistance/index": 371,
	"./fa-IR/_lib/formatDistance/index.js": 371,
	"./fa-IR/_lib/formatLong": 372,
	"./fa-IR/_lib/formatLong/": 372,
	"./fa-IR/_lib/formatLong/index": 372,
	"./fa-IR/_lib/formatLong/index.js": 372,
	"./fa-IR/_lib/formatRelative": 373,
	"./fa-IR/_lib/formatRelative/": 373,
	"./fa-IR/_lib/formatRelative/index": 373,
	"./fa-IR/_lib/formatRelative/index.js": 373,
	"./fa-IR/_lib/localize": 374,
	"./fa-IR/_lib/localize/": 374,
	"./fa-IR/_lib/localize/index": 374,
	"./fa-IR/_lib/localize/index.js": 374,
	"./fa-IR/_lib/match": 375,
	"./fa-IR/_lib/match/": 375,
	"./fa-IR/_lib/match/index": 375,
	"./fa-IR/_lib/match/index.js": 375,
	"./fa-IR/index": 818,
	"./fa-IR/index.d.ts": 1126,
	"./fa-IR/index.js": 818,
	"./fa-IR/index.js.flow": 1127,
	"./fa-IR/package": 919,
	"./fa-IR/package.json": 919,
	"./fi": 638,
	"./fi/": 638,
	"./fi/_lib/formatDistance": 376,
	"./fi/_lib/formatDistance/": 376,
	"./fi/_lib/formatDistance/index": 376,
	"./fi/_lib/formatDistance/index.js": 376,
	"./fi/_lib/formatLong": 377,
	"./fi/_lib/formatLong/": 377,
	"./fi/_lib/formatLong/index": 377,
	"./fi/_lib/formatLong/index.js": 377,
	"./fi/_lib/formatRelative": 378,
	"./fi/_lib/formatRelative/": 378,
	"./fi/_lib/formatRelative/index": 378,
	"./fi/_lib/formatRelative/index.js": 378,
	"./fi/_lib/localize": 379,
	"./fi/_lib/localize/": 379,
	"./fi/_lib/localize/index": 379,
	"./fi/_lib/localize/index.js": 379,
	"./fi/_lib/match": 380,
	"./fi/_lib/match/": 380,
	"./fi/_lib/match/index": 380,
	"./fi/_lib/match/index.js": 380,
	"./fi/index": 819,
	"./fi/index.d.ts": 1128,
	"./fi/index.js": 819,
	"./fi/index.js.flow": 1129,
	"./fi/package": 920,
	"./fi/package.json": 920,
	"./fr": 691,
	"./fr-CA": 692,
	"./fr-CA/": 692,
	"./fr-CA/_lib/formatLong": 381,
	"./fr-CA/_lib/formatLong/": 381,
	"./fr-CA/_lib/formatLong/index": 381,
	"./fr-CA/_lib/formatLong/index.js": 381,
	"./fr-CA/index": 820,
	"./fr-CA/index.d.ts": 1130,
	"./fr-CA/index.js": 820,
	"./fr-CA/index.js.flow": 1131,
	"./fr-CA/package": 921,
	"./fr-CA/package.json": 921,
	"./fr-CH": 639,
	"./fr-CH/": 639,
	"./fr-CH/_lib/formatDistance": 382,
	"./fr-CH/_lib/formatDistance/": 382,
	"./fr-CH/_lib/formatDistance/index": 382,
	"./fr-CH/_lib/formatDistance/index.js": 382,
	"./fr-CH/_lib/formatLong": 383,
	"./fr-CH/_lib/formatLong/": 383,
	"./fr-CH/_lib/formatLong/index": 383,
	"./fr-CH/_lib/formatLong/index.js": 383,
	"./fr-CH/_lib/formatRelative": 384,
	"./fr-CH/_lib/formatRelative/": 384,
	"./fr-CH/_lib/formatRelative/index": 384,
	"./fr-CH/_lib/formatRelative/index.js": 384,
	"./fr-CH/_lib/formatters": 713,
	"./fr-CH/_lib/formatters/": 713,
	"./fr-CH/_lib/formatters/index": 713,
	"./fr-CH/_lib/formatters/index.js": 713,
	"./fr-CH/_lib/localize": 385,
	"./fr-CH/_lib/localize/": 385,
	"./fr-CH/_lib/localize/index": 385,
	"./fr-CH/_lib/localize/index.js": 385,
	"./fr-CH/_lib/match": 386,
	"./fr-CH/_lib/match/": 386,
	"./fr-CH/_lib/match/index": 386,
	"./fr-CH/_lib/match/index.js": 386,
	"./fr-CH/index": 821,
	"./fr-CH/index.d.ts": 1132,
	"./fr-CH/index.js": 821,
	"./fr-CH/index.js.flow": 1133,
	"./fr-CH/package": 922,
	"./fr-CH/package.json": 922,
	"./fr/": 691,
	"./fr/_lib/formatDistance": 227,
	"./fr/_lib/formatDistance/": 227,
	"./fr/_lib/formatDistance/index": 227,
	"./fr/_lib/formatDistance/index.js": 227,
	"./fr/_lib/formatLong": 387,
	"./fr/_lib/formatLong/": 387,
	"./fr/_lib/formatLong/index": 387,
	"./fr/_lib/formatLong/index.js": 387,
	"./fr/_lib/formatRelative": 228,
	"./fr/_lib/formatRelative/": 228,
	"./fr/_lib/formatRelative/index": 228,
	"./fr/_lib/formatRelative/index.js": 228,
	"./fr/_lib/formatters": 714,
	"./fr/_lib/formatters/": 714,
	"./fr/_lib/formatters/index": 714,
	"./fr/_lib/formatters/index.js": 714,
	"./fr/_lib/localize": 229,
	"./fr/_lib/localize/": 229,
	"./fr/_lib/localize/index": 229,
	"./fr/_lib/localize/index.js": 229,
	"./fr/_lib/match": 230,
	"./fr/_lib/match/": 230,
	"./fr/_lib/match/index": 230,
	"./fr/_lib/match/index.js": 230,
	"./fr/index": 822,
	"./fr/index.d.ts": 1134,
	"./fr/index.js": 822,
	"./fr/index.js.flow": 1135,
	"./fr/package": 923,
	"./fr/package.json": 923,
	"./gd": 640,
	"./gd/": 640,
	"./gd/_lib/formatDistance": 388,
	"./gd/_lib/formatDistance/": 388,
	"./gd/_lib/formatDistance/index": 388,
	"./gd/_lib/formatDistance/index.js": 388,
	"./gd/_lib/formatLong": 389,
	"./gd/_lib/formatLong/": 389,
	"./gd/_lib/formatLong/index": 389,
	"./gd/_lib/formatLong/index.js": 389,
	"./gd/_lib/formatRelative": 390,
	"./gd/_lib/formatRelative/": 390,
	"./gd/_lib/formatRelative/index": 390,
	"./gd/_lib/formatRelative/index.js": 390,
	"./gd/_lib/localize": 391,
	"./gd/_lib/localize/": 391,
	"./gd/_lib/localize/index": 391,
	"./gd/_lib/localize/index.js": 391,
	"./gd/_lib/match": 392,
	"./gd/_lib/match/": 392,
	"./gd/_lib/match/index": 392,
	"./gd/_lib/match/index.js": 392,
	"./gd/index": 823,
	"./gd/index.d.ts": 1136,
	"./gd/index.js": 823,
	"./gd/index.js.flow": 1137,
	"./gd/package": 924,
	"./gd/package.json": 924,
	"./gl": 641,
	"./gl/": 641,
	"./gl/_lib/formatDistance": 393,
	"./gl/_lib/formatDistance/": 393,
	"./gl/_lib/formatDistance/index": 393,
	"./gl/_lib/formatDistance/index.js": 393,
	"./gl/_lib/formatLong": 394,
	"./gl/_lib/formatLong/": 394,
	"./gl/_lib/formatLong/index": 394,
	"./gl/_lib/formatLong/index.js": 394,
	"./gl/_lib/formatRelative": 395,
	"./gl/_lib/formatRelative/": 395,
	"./gl/_lib/formatRelative/index": 395,
	"./gl/_lib/formatRelative/index.js": 395,
	"./gl/_lib/localize": 396,
	"./gl/_lib/localize/": 396,
	"./gl/_lib/localize/index": 396,
	"./gl/_lib/localize/index.js": 396,
	"./gl/_lib/match": 397,
	"./gl/_lib/match/": 397,
	"./gl/_lib/match/index": 397,
	"./gl/_lib/match/index.js": 397,
	"./gl/index": 824,
	"./gl/index.d.ts": 1138,
	"./gl/index.js": 824,
	"./gl/index.js.flow": 1139,
	"./gl/package": 925,
	"./gl/package.json": 925,
	"./gu": 642,
	"./gu/": 642,
	"./gu/_lib/formatDistance": 398,
	"./gu/_lib/formatDistance/": 398,
	"./gu/_lib/formatDistance/index": 398,
	"./gu/_lib/formatDistance/index.js": 398,
	"./gu/_lib/formatLong": 399,
	"./gu/_lib/formatLong/": 399,
	"./gu/_lib/formatLong/index": 399,
	"./gu/_lib/formatLong/index.js": 399,
	"./gu/_lib/formatRelative": 400,
	"./gu/_lib/formatRelative/": 400,
	"./gu/_lib/formatRelative/index": 400,
	"./gu/_lib/formatRelative/index.js": 400,
	"./gu/_lib/localize": 401,
	"./gu/_lib/localize/": 401,
	"./gu/_lib/localize/index": 401,
	"./gu/_lib/localize/index.js": 401,
	"./gu/_lib/match": 402,
	"./gu/_lib/match/": 402,
	"./gu/_lib/match/index": 402,
	"./gu/_lib/match/index.js": 402,
	"./gu/index": 825,
	"./gu/index.d.ts": 1140,
	"./gu/index.js": 825,
	"./gu/index.js.flow": 1141,
	"./gu/package": 926,
	"./gu/package.json": 926,
	"./he": 643,
	"./he/": 643,
	"./he/_lib/formatDistance": 403,
	"./he/_lib/formatDistance/": 403,
	"./he/_lib/formatDistance/index": 403,
	"./he/_lib/formatDistance/index.js": 403,
	"./he/_lib/formatLong": 404,
	"./he/_lib/formatLong/": 404,
	"./he/_lib/formatLong/index": 404,
	"./he/_lib/formatLong/index.js": 404,
	"./he/_lib/formatRelative": 405,
	"./he/_lib/formatRelative/": 405,
	"./he/_lib/formatRelative/index": 405,
	"./he/_lib/formatRelative/index.js": 405,
	"./he/_lib/localize": 406,
	"./he/_lib/localize/": 406,
	"./he/_lib/localize/index": 406,
	"./he/_lib/localize/index.js": 406,
	"./he/_lib/match": 407,
	"./he/_lib/match/": 407,
	"./he/_lib/match/index": 407,
	"./he/_lib/match/index.js": 407,
	"./he/index": 826,
	"./he/index.d.ts": 1142,
	"./he/index.js": 826,
	"./he/index.js.flow": 1143,
	"./he/package": 927,
	"./he/package.json": 927,
	"./hi": 644,
	"./hi/": 644,
	"./hi/_lib/formatDistance": 408,
	"./hi/_lib/formatDistance/": 408,
	"./hi/_lib/formatDistance/index": 408,
	"./hi/_lib/formatDistance/index.js": 408,
	"./hi/_lib/formatLong": 409,
	"./hi/_lib/formatLong/": 409,
	"./hi/_lib/formatLong/index": 409,
	"./hi/_lib/formatLong/index.js": 409,
	"./hi/_lib/formatRelative": 410,
	"./hi/_lib/formatRelative/": 410,
	"./hi/_lib/formatRelative/index": 410,
	"./hi/_lib/formatRelative/index.js": 410,
	"./hi/_lib/localize": 204,
	"./hi/_lib/localize/": 204,
	"./hi/_lib/localize/index": 204,
	"./hi/_lib/localize/index.js": 204,
	"./hi/_lib/match": 411,
	"./hi/_lib/match/": 411,
	"./hi/_lib/match/index": 411,
	"./hi/_lib/match/index.js": 411,
	"./hi/index": 827,
	"./hi/index.d.ts": 1144,
	"./hi/index.js": 827,
	"./hi/index.js.flow": 1145,
	"./hi/package": 928,
	"./hi/package.json": 928,
	"./hr": 645,
	"./hr/": 645,
	"./hr/_lib/formatDistance": 412,
	"./hr/_lib/formatDistance/": 412,
	"./hr/_lib/formatDistance/index": 412,
	"./hr/_lib/formatDistance/index.js": 412,
	"./hr/_lib/formatLong": 413,
	"./hr/_lib/formatLong/": 413,
	"./hr/_lib/formatLong/index": 413,
	"./hr/_lib/formatLong/index.js": 413,
	"./hr/_lib/formatRelative": 414,
	"./hr/_lib/formatRelative/": 414,
	"./hr/_lib/formatRelative/index": 414,
	"./hr/_lib/formatRelative/index.js": 414,
	"./hr/_lib/localize": 415,
	"./hr/_lib/localize/": 415,
	"./hr/_lib/localize/index": 415,
	"./hr/_lib/localize/index.js": 415,
	"./hr/_lib/match": 416,
	"./hr/_lib/match/": 416,
	"./hr/_lib/match/index": 416,
	"./hr/_lib/match/index.js": 416,
	"./hr/index": 828,
	"./hr/index.d.ts": 1146,
	"./hr/index.js": 828,
	"./hr/index.js.flow": 1147,
	"./hr/package": 929,
	"./hr/package.json": 929,
	"./hu": 646,
	"./hu/": 646,
	"./hu/_lib/formatDistance": 417,
	"./hu/_lib/formatDistance/": 417,
	"./hu/_lib/formatDistance/index": 417,
	"./hu/_lib/formatDistance/index.js": 417,
	"./hu/_lib/formatLong": 418,
	"./hu/_lib/formatLong/": 418,
	"./hu/_lib/formatLong/index": 418,
	"./hu/_lib/formatLong/index.js": 418,
	"./hu/_lib/formatRelative": 419,
	"./hu/_lib/formatRelative/": 419,
	"./hu/_lib/formatRelative/index": 419,
	"./hu/_lib/formatRelative/index.js": 419,
	"./hu/_lib/localize": 420,
	"./hu/_lib/localize/": 420,
	"./hu/_lib/localize/index": 420,
	"./hu/_lib/localize/index.js": 420,
	"./hu/_lib/match": 421,
	"./hu/_lib/match/": 421,
	"./hu/_lib/match/index": 421,
	"./hu/_lib/match/index.js": 421,
	"./hu/index": 829,
	"./hu/index.d.ts": 1148,
	"./hu/index.js": 829,
	"./hu/index.js.flow": 1149,
	"./hu/package": 930,
	"./hu/package.json": 930,
	"./hy": 647,
	"./hy/": 647,
	"./hy/_lib/formatDistance": 422,
	"./hy/_lib/formatDistance/": 422,
	"./hy/_lib/formatDistance/index": 422,
	"./hy/_lib/formatDistance/index.js": 422,
	"./hy/_lib/formatLong": 423,
	"./hy/_lib/formatLong/": 423,
	"./hy/_lib/formatLong/index": 423,
	"./hy/_lib/formatLong/index.js": 423,
	"./hy/_lib/formatRelative": 424,
	"./hy/_lib/formatRelative/": 424,
	"./hy/_lib/formatRelative/index": 424,
	"./hy/_lib/formatRelative/index.js": 424,
	"./hy/_lib/localize": 425,
	"./hy/_lib/localize/": 425,
	"./hy/_lib/localize/index": 425,
	"./hy/_lib/localize/index.js": 425,
	"./hy/_lib/match": 426,
	"./hy/_lib/match/": 426,
	"./hy/_lib/match/index": 426,
	"./hy/_lib/match/index.js": 426,
	"./hy/index": 830,
	"./hy/index.d.ts": 1150,
	"./hy/index.js": 830,
	"./hy/index.js.flow": 1151,
	"./hy/package": 931,
	"./hy/package.json": 931,
	"./id": 648,
	"./id/": 648,
	"./id/_lib/formatDistance": 427,
	"./id/_lib/formatDistance/": 427,
	"./id/_lib/formatDistance/index": 427,
	"./id/_lib/formatDistance/index.js": 427,
	"./id/_lib/formatLong": 428,
	"./id/_lib/formatLong/": 428,
	"./id/_lib/formatLong/index": 428,
	"./id/_lib/formatLong/index.js": 428,
	"./id/_lib/formatRelative": 429,
	"./id/_lib/formatRelative/": 429,
	"./id/_lib/formatRelative/index": 429,
	"./id/_lib/formatRelative/index.js": 429,
	"./id/_lib/localize": 430,
	"./id/_lib/localize/": 430,
	"./id/_lib/localize/index": 430,
	"./id/_lib/localize/index.js": 430,
	"./id/_lib/match": 431,
	"./id/_lib/match/": 431,
	"./id/_lib/match/index": 431,
	"./id/_lib/match/index.js": 431,
	"./id/index": 831,
	"./id/index.d.ts": 1152,
	"./id/index.js": 831,
	"./id/index.js.flow": 1153,
	"./id/package": 932,
	"./id/package.json": 932,
	"./index": 933,
	"./index.js": 933,
	"./index.js.flow": 1154,
	"./is": 649,
	"./is/": 649,
	"./is/_lib/formatDistance": 432,
	"./is/_lib/formatDistance/": 432,
	"./is/_lib/formatDistance/index": 432,
	"./is/_lib/formatDistance/index.js": 432,
	"./is/_lib/formatLong": 433,
	"./is/_lib/formatLong/": 433,
	"./is/_lib/formatLong/index": 433,
	"./is/_lib/formatLong/index.js": 433,
	"./is/_lib/formatRelative": 434,
	"./is/_lib/formatRelative/": 434,
	"./is/_lib/formatRelative/index": 434,
	"./is/_lib/formatRelative/index.js": 434,
	"./is/_lib/localize": 435,
	"./is/_lib/localize/": 435,
	"./is/_lib/localize/index": 435,
	"./is/_lib/localize/index.js": 435,
	"./is/_lib/match": 436,
	"./is/_lib/match/": 436,
	"./is/_lib/match/index": 436,
	"./is/_lib/match/index.js": 436,
	"./is/index": 832,
	"./is/index.d.ts": 1155,
	"./is/index.js": 832,
	"./is/index.js.flow": 1156,
	"./is/package": 934,
	"./is/package.json": 934,
	"./it": 650,
	"./it/": 650,
	"./it/_lib/formatDistance": 437,
	"./it/_lib/formatDistance/": 437,
	"./it/_lib/formatDistance/index": 437,
	"./it/_lib/formatDistance/index.js": 437,
	"./it/_lib/formatLong": 438,
	"./it/_lib/formatLong/": 438,
	"./it/_lib/formatLong/index": 438,
	"./it/_lib/formatLong/index.js": 438,
	"./it/_lib/formatRelative": 439,
	"./it/_lib/formatRelative/": 439,
	"./it/_lib/formatRelative/index": 439,
	"./it/_lib/formatRelative/index.js": 439,
	"./it/_lib/localize": 440,
	"./it/_lib/localize/": 440,
	"./it/_lib/localize/index": 440,
	"./it/_lib/localize/index.js": 440,
	"./it/_lib/match": 441,
	"./it/_lib/match/": 441,
	"./it/_lib/match/index": 441,
	"./it/_lib/match/index.js": 441,
	"./it/index": 833,
	"./it/index.d.ts": 1157,
	"./it/index.js": 833,
	"./it/index.js.flow": 1158,
	"./it/package": 935,
	"./it/package.json": 935,
	"./ja": 651,
	"./ja/": 651,
	"./ja/_lib/formatDistance": 442,
	"./ja/_lib/formatDistance/": 442,
	"./ja/_lib/formatDistance/index": 442,
	"./ja/_lib/formatDistance/index.js": 442,
	"./ja/_lib/formatLong": 443,
	"./ja/_lib/formatLong/": 443,
	"./ja/_lib/formatLong/index": 443,
	"./ja/_lib/formatLong/index.js": 443,
	"./ja/_lib/formatRelative": 444,
	"./ja/_lib/formatRelative/": 444,
	"./ja/_lib/formatRelative/index": 444,
	"./ja/_lib/formatRelative/index.js": 444,
	"./ja/_lib/localize": 445,
	"./ja/_lib/localize/": 445,
	"./ja/_lib/localize/index": 445,
	"./ja/_lib/localize/index.js": 445,
	"./ja/_lib/match": 446,
	"./ja/_lib/match/": 446,
	"./ja/_lib/match/index": 446,
	"./ja/_lib/match/index.js": 446,
	"./ja/index": 834,
	"./ja/index.d.ts": 1159,
	"./ja/index.js": 834,
	"./ja/index.js.flow": 1160,
	"./ja/package": 936,
	"./ja/package.json": 936,
	"./ka": 652,
	"./ka/": 652,
	"./ka/_lib/formatDistance": 447,
	"./ka/_lib/formatDistance/": 447,
	"./ka/_lib/formatDistance/index": 447,
	"./ka/_lib/formatDistance/index.js": 447,
	"./ka/_lib/formatLong": 448,
	"./ka/_lib/formatLong/": 448,
	"./ka/_lib/formatLong/index": 448,
	"./ka/_lib/formatLong/index.js": 448,
	"./ka/_lib/formatRelative": 449,
	"./ka/_lib/formatRelative/": 449,
	"./ka/_lib/formatRelative/index": 449,
	"./ka/_lib/formatRelative/index.js": 449,
	"./ka/_lib/localize": 450,
	"./ka/_lib/localize/": 450,
	"./ka/_lib/localize/index": 450,
	"./ka/_lib/localize/index.js": 450,
	"./ka/_lib/match": 451,
	"./ka/_lib/match/": 451,
	"./ka/_lib/match/index": 451,
	"./ka/_lib/match/index.js": 451,
	"./ka/index": 835,
	"./ka/index.d.ts": 1161,
	"./ka/index.js": 835,
	"./ka/index.js.flow": 1162,
	"./ka/package": 937,
	"./ka/package.json": 937,
	"./kk": 653,
	"./kk/": 653,
	"./kk/_lib/formatDistance": 452,
	"./kk/_lib/formatDistance/": 452,
	"./kk/_lib/formatDistance/index": 452,
	"./kk/_lib/formatDistance/index.js": 452,
	"./kk/_lib/formatLong": 453,
	"./kk/_lib/formatLong/": 453,
	"./kk/_lib/formatLong/index": 453,
	"./kk/_lib/formatLong/index.js": 453,
	"./kk/_lib/formatRelative": 454,
	"./kk/_lib/formatRelative/": 454,
	"./kk/_lib/formatRelative/index": 454,
	"./kk/_lib/formatRelative/index.js": 454,
	"./kk/_lib/localize": 455,
	"./kk/_lib/localize/": 455,
	"./kk/_lib/localize/index": 455,
	"./kk/_lib/localize/index.js": 455,
	"./kk/_lib/match": 456,
	"./kk/_lib/match/": 456,
	"./kk/_lib/match/index": 456,
	"./kk/_lib/match/index.js": 456,
	"./kk/index": 836,
	"./kk/index.d.ts": 1163,
	"./kk/index.js": 836,
	"./kk/index.js.flow": 1164,
	"./kk/package": 938,
	"./kk/package.json": 938,
	"./kn": 654,
	"./kn/": 654,
	"./kn/_lib/formatDistance": 457,
	"./kn/_lib/formatDistance/": 457,
	"./kn/_lib/formatDistance/index": 457,
	"./kn/_lib/formatDistance/index.js": 457,
	"./kn/_lib/formatLong": 458,
	"./kn/_lib/formatLong/": 458,
	"./kn/_lib/formatLong/index": 458,
	"./kn/_lib/formatLong/index.js": 458,
	"./kn/_lib/formatRelative": 459,
	"./kn/_lib/formatRelative/": 459,
	"./kn/_lib/formatRelative/index": 459,
	"./kn/_lib/formatRelative/index.js": 459,
	"./kn/_lib/localize": 460,
	"./kn/_lib/localize/": 460,
	"./kn/_lib/localize/index": 460,
	"./kn/_lib/localize/index.js": 460,
	"./kn/_lib/match": 461,
	"./kn/_lib/match/": 461,
	"./kn/_lib/match/index": 461,
	"./kn/_lib/match/index.js": 461,
	"./kn/index": 837,
	"./kn/index.d.ts": 1165,
	"./kn/index.js": 837,
	"./kn/index.js.flow": 1166,
	"./kn/package": 939,
	"./kn/package.json": 939,
	"./ko": 655,
	"./ko/": 655,
	"./ko/_lib/formatDistance": 462,
	"./ko/_lib/formatDistance/": 462,
	"./ko/_lib/formatDistance/index": 462,
	"./ko/_lib/formatDistance/index.js": 462,
	"./ko/_lib/formatLong": 463,
	"./ko/_lib/formatLong/": 463,
	"./ko/_lib/formatLong/index": 463,
	"./ko/_lib/formatLong/index.js": 463,
	"./ko/_lib/formatRelative": 464,
	"./ko/_lib/formatRelative/": 464,
	"./ko/_lib/formatRelative/index": 464,
	"./ko/_lib/formatRelative/index.js": 464,
	"./ko/_lib/localize": 465,
	"./ko/_lib/localize/": 465,
	"./ko/_lib/localize/index": 465,
	"./ko/_lib/localize/index.js": 465,
	"./ko/_lib/match": 466,
	"./ko/_lib/match/": 466,
	"./ko/_lib/match/index": 466,
	"./ko/_lib/match/index.js": 466,
	"./ko/index": 838,
	"./ko/index.d.ts": 1167,
	"./ko/index.js": 838,
	"./ko/index.js.flow": 1168,
	"./ko/package": 940,
	"./ko/package.json": 940,
	"./lb": 656,
	"./lb/": 656,
	"./lb/_lib/formatDistance": 467,
	"./lb/_lib/formatDistance/": 467,
	"./lb/_lib/formatDistance/index": 467,
	"./lb/_lib/formatDistance/index.js": 467,
	"./lb/_lib/formatLong": 468,
	"./lb/_lib/formatLong/": 468,
	"./lb/_lib/formatLong/index": 468,
	"./lb/_lib/formatLong/index.js": 468,
	"./lb/_lib/formatRelative": 469,
	"./lb/_lib/formatRelative/": 469,
	"./lb/_lib/formatRelative/index": 469,
	"./lb/_lib/formatRelative/index.js": 469,
	"./lb/_lib/localize": 470,
	"./lb/_lib/localize/": 470,
	"./lb/_lib/localize/index": 470,
	"./lb/_lib/localize/index.js": 470,
	"./lb/_lib/match": 471,
	"./lb/_lib/match/": 471,
	"./lb/_lib/match/index": 471,
	"./lb/_lib/match/index.js": 471,
	"./lb/index": 839,
	"./lb/index.d.ts": 1169,
	"./lb/index.js": 839,
	"./lb/index.js.flow": 1170,
	"./lb/package": 941,
	"./lb/package.json": 941,
	"./lt": 657,
	"./lt/": 657,
	"./lt/_lib/formatDistance": 472,
	"./lt/_lib/formatDistance/": 472,
	"./lt/_lib/formatDistance/index": 472,
	"./lt/_lib/formatDistance/index.js": 472,
	"./lt/_lib/formatLong": 473,
	"./lt/_lib/formatLong/": 473,
	"./lt/_lib/formatLong/index": 473,
	"./lt/_lib/formatLong/index.js": 473,
	"./lt/_lib/formatRelative": 474,
	"./lt/_lib/formatRelative/": 474,
	"./lt/_lib/formatRelative/index": 474,
	"./lt/_lib/formatRelative/index.js": 474,
	"./lt/_lib/localize": 475,
	"./lt/_lib/localize/": 475,
	"./lt/_lib/localize/index": 475,
	"./lt/_lib/localize/index.js": 475,
	"./lt/_lib/match": 476,
	"./lt/_lib/match/": 476,
	"./lt/_lib/match/index": 476,
	"./lt/_lib/match/index.js": 476,
	"./lt/index": 840,
	"./lt/index.d.ts": 1171,
	"./lt/index.js": 840,
	"./lt/index.js.flow": 1172,
	"./lt/package": 942,
	"./lt/package.json": 942,
	"./lv": 658,
	"./lv/": 658,
	"./lv/_lib/formatDistance": 477,
	"./lv/_lib/formatDistance/": 477,
	"./lv/_lib/formatDistance/index": 477,
	"./lv/_lib/formatDistance/index.js": 477,
	"./lv/_lib/formatLong": 478,
	"./lv/_lib/formatLong/": 478,
	"./lv/_lib/formatLong/index": 478,
	"./lv/_lib/formatLong/index.js": 478,
	"./lv/_lib/formatRelative": 479,
	"./lv/_lib/formatRelative/": 479,
	"./lv/_lib/formatRelative/index": 479,
	"./lv/_lib/formatRelative/index.js": 479,
	"./lv/_lib/localize": 480,
	"./lv/_lib/localize/": 480,
	"./lv/_lib/localize/index": 480,
	"./lv/_lib/localize/index.js": 480,
	"./lv/_lib/match": 481,
	"./lv/_lib/match/": 481,
	"./lv/_lib/match/index": 481,
	"./lv/_lib/match/index.js": 481,
	"./lv/index": 841,
	"./lv/index.d.ts": 1173,
	"./lv/index.js": 841,
	"./lv/index.js.flow": 1174,
	"./lv/package": 943,
	"./lv/package.json": 943,
	"./mk": 659,
	"./mk/": 659,
	"./mk/_lib/formatDistance": 482,
	"./mk/_lib/formatDistance/": 482,
	"./mk/_lib/formatDistance/index": 482,
	"./mk/_lib/formatDistance/index.js": 482,
	"./mk/_lib/formatLong": 483,
	"./mk/_lib/formatLong/": 483,
	"./mk/_lib/formatLong/index": 483,
	"./mk/_lib/formatLong/index.js": 483,
	"./mk/_lib/formatRelative": 484,
	"./mk/_lib/formatRelative/": 484,
	"./mk/_lib/formatRelative/index": 484,
	"./mk/_lib/formatRelative/index.js": 484,
	"./mk/_lib/localize": 485,
	"./mk/_lib/localize/": 485,
	"./mk/_lib/localize/index": 485,
	"./mk/_lib/localize/index.js": 485,
	"./mk/_lib/match": 486,
	"./mk/_lib/match/": 486,
	"./mk/_lib/match/index": 486,
	"./mk/_lib/match/index.js": 486,
	"./mk/index": 842,
	"./mk/index.d.ts": 1175,
	"./mk/index.js": 842,
	"./mk/index.js.flow": 1176,
	"./mk/package": 944,
	"./mk/package.json": 944,
	"./ms": 660,
	"./ms/": 660,
	"./ms/_lib/formatDistance": 487,
	"./ms/_lib/formatDistance/": 487,
	"./ms/_lib/formatDistance/index": 487,
	"./ms/_lib/formatDistance/index.js": 487,
	"./ms/_lib/formatLong": 488,
	"./ms/_lib/formatLong/": 488,
	"./ms/_lib/formatLong/index": 488,
	"./ms/_lib/formatLong/index.js": 488,
	"./ms/_lib/formatRelative": 489,
	"./ms/_lib/formatRelative/": 489,
	"./ms/_lib/formatRelative/index": 489,
	"./ms/_lib/formatRelative/index.js": 489,
	"./ms/_lib/localize": 490,
	"./ms/_lib/localize/": 490,
	"./ms/_lib/localize/index": 490,
	"./ms/_lib/localize/index.js": 490,
	"./ms/_lib/match": 491,
	"./ms/_lib/match/": 491,
	"./ms/_lib/match/index": 491,
	"./ms/_lib/match/index.js": 491,
	"./ms/index": 843,
	"./ms/index.d.ts": 1177,
	"./ms/index.js": 843,
	"./ms/index.js.flow": 1178,
	"./ms/package": 945,
	"./ms/package.json": 945,
	"./mt": 661,
	"./mt/": 661,
	"./mt/_lib/formatDistance": 492,
	"./mt/_lib/formatDistance/": 492,
	"./mt/_lib/formatDistance/index": 492,
	"./mt/_lib/formatDistance/index.js": 492,
	"./mt/_lib/formatLong": 493,
	"./mt/_lib/formatLong/": 493,
	"./mt/_lib/formatLong/index": 493,
	"./mt/_lib/formatLong/index.js": 493,
	"./mt/_lib/formatRelative": 494,
	"./mt/_lib/formatRelative/": 494,
	"./mt/_lib/formatRelative/index": 494,
	"./mt/_lib/formatRelative/index.js": 494,
	"./mt/_lib/localize": 495,
	"./mt/_lib/localize/": 495,
	"./mt/_lib/localize/index": 495,
	"./mt/_lib/localize/index.js": 495,
	"./mt/_lib/match": 496,
	"./mt/_lib/match/": 496,
	"./mt/_lib/match/index": 496,
	"./mt/_lib/match/index.js": 496,
	"./mt/index": 844,
	"./mt/index.d.ts": 1179,
	"./mt/index.js": 844,
	"./mt/index.js.flow": 1180,
	"./mt/package": 946,
	"./mt/package.json": 946,
	"./nb": 662,
	"./nb/": 662,
	"./nb/_lib/formatDistance": 497,
	"./nb/_lib/formatDistance/": 497,
	"./nb/_lib/formatDistance/index": 497,
	"./nb/_lib/formatDistance/index.js": 497,
	"./nb/_lib/formatLong": 498,
	"./nb/_lib/formatLong/": 498,
	"./nb/_lib/formatLong/index": 498,
	"./nb/_lib/formatLong/index.js": 498,
	"./nb/_lib/formatRelative": 499,
	"./nb/_lib/formatRelative/": 499,
	"./nb/_lib/formatRelative/index": 499,
	"./nb/_lib/formatRelative/index.js": 499,
	"./nb/_lib/localize": 500,
	"./nb/_lib/localize/": 500,
	"./nb/_lib/localize/index": 500,
	"./nb/_lib/localize/index.js": 500,
	"./nb/_lib/match": 501,
	"./nb/_lib/match/": 501,
	"./nb/_lib/match/index": 501,
	"./nb/_lib/match/index.js": 501,
	"./nb/index": 845,
	"./nb/index.d.ts": 1181,
	"./nb/index.js": 845,
	"./nb/index.js.flow": 1182,
	"./nb/package": 947,
	"./nb/package.json": 947,
	"./nl": 663,
	"./nl-BE": 664,
	"./nl-BE/": 664,
	"./nl-BE/_lib/formatDistance": 507,
	"./nl-BE/_lib/formatDistance/": 507,
	"./nl-BE/_lib/formatDistance/index": 507,
	"./nl-BE/_lib/formatDistance/index.js": 507,
	"./nl-BE/_lib/formatLong": 508,
	"./nl-BE/_lib/formatLong/": 508,
	"./nl-BE/_lib/formatLong/index": 508,
	"./nl-BE/_lib/formatLong/index.js": 508,
	"./nl-BE/_lib/formatRelative": 509,
	"./nl-BE/_lib/formatRelative/": 509,
	"./nl-BE/_lib/formatRelative/index": 509,
	"./nl-BE/_lib/formatRelative/index.js": 509,
	"./nl-BE/_lib/localize": 510,
	"./nl-BE/_lib/localize/": 510,
	"./nl-BE/_lib/localize/index": 510,
	"./nl-BE/_lib/localize/index.js": 510,
	"./nl-BE/_lib/match": 511,
	"./nl-BE/_lib/match/": 511,
	"./nl-BE/_lib/match/index": 511,
	"./nl-BE/_lib/match/index.js": 511,
	"./nl-BE/index": 847,
	"./nl-BE/index.d.ts": 1183,
	"./nl-BE/index.js": 847,
	"./nl-BE/index.js.flow": 1184,
	"./nl-BE/package": 948,
	"./nl-BE/package.json": 948,
	"./nl/": 663,
	"./nl/_lib/formatDistance": 502,
	"./nl/_lib/formatDistance/": 502,
	"./nl/_lib/formatDistance/index": 502,
	"./nl/_lib/formatDistance/index.js": 502,
	"./nl/_lib/formatLong": 503,
	"./nl/_lib/formatLong/": 503,
	"./nl/_lib/formatLong/index": 503,
	"./nl/_lib/formatLong/index.js": 503,
	"./nl/_lib/formatRelative": 504,
	"./nl/_lib/formatRelative/": 504,
	"./nl/_lib/formatRelative/index": 504,
	"./nl/_lib/formatRelative/index.js": 504,
	"./nl/_lib/localize": 505,
	"./nl/_lib/localize/": 505,
	"./nl/_lib/localize/index": 505,
	"./nl/_lib/localize/index.js": 505,
	"./nl/_lib/match": 506,
	"./nl/_lib/match/": 506,
	"./nl/_lib/match/index": 506,
	"./nl/_lib/match/index.js": 506,
	"./nl/index": 846,
	"./nl/index.d.ts": 1185,
	"./nl/index.js": 846,
	"./nl/index.js.flow": 1186,
	"./nl/package": 949,
	"./nl/package.json": 949,
	"./nn": 665,
	"./nn/": 665,
	"./nn/_lib/formatDistance": 512,
	"./nn/_lib/formatDistance/": 512,
	"./nn/_lib/formatDistance/index": 512,
	"./nn/_lib/formatDistance/index.js": 512,
	"./nn/_lib/formatLong": 513,
	"./nn/_lib/formatLong/": 513,
	"./nn/_lib/formatLong/index": 513,
	"./nn/_lib/formatLong/index.js": 513,
	"./nn/_lib/formatRelative": 514,
	"./nn/_lib/formatRelative/": 514,
	"./nn/_lib/formatRelative/index": 514,
	"./nn/_lib/formatRelative/index.js": 514,
	"./nn/_lib/localize": 515,
	"./nn/_lib/localize/": 515,
	"./nn/_lib/localize/index": 515,
	"./nn/_lib/localize/index.js": 515,
	"./nn/_lib/match": 516,
	"./nn/_lib/match/": 516,
	"./nn/_lib/match/index": 516,
	"./nn/_lib/match/index.js": 516,
	"./nn/index": 848,
	"./nn/index.d.ts": 1187,
	"./nn/index.js": 848,
	"./nn/index.js.flow": 1188,
	"./nn/package": 950,
	"./nn/package.json": 950,
	"./package": 951,
	"./package.json": 951,
	"./pl": 666,
	"./pl/": 666,
	"./pl/_lib/formatDistance": 517,
	"./pl/_lib/formatDistance/": 517,
	"./pl/_lib/formatDistance/index": 517,
	"./pl/_lib/formatDistance/index.js": 517,
	"./pl/_lib/formatLong": 518,
	"./pl/_lib/formatLong/": 518,
	"./pl/_lib/formatLong/index": 518,
	"./pl/_lib/formatLong/index.js": 518,
	"./pl/_lib/formatRelative": 519,
	"./pl/_lib/formatRelative/": 519,
	"./pl/_lib/formatRelative/index": 519,
	"./pl/_lib/formatRelative/index.js": 519,
	"./pl/_lib/localize": 520,
	"./pl/_lib/localize/": 520,
	"./pl/_lib/localize/index": 520,
	"./pl/_lib/localize/index.js": 520,
	"./pl/_lib/match": 521,
	"./pl/_lib/match/": 521,
	"./pl/_lib/match/index": 521,
	"./pl/_lib/match/index.js": 521,
	"./pl/index": 849,
	"./pl/index.d.ts": 1189,
	"./pl/index.js": 849,
	"./pl/index.js.flow": 1190,
	"./pl/package": 952,
	"./pl/package.json": 952,
	"./pt": 667,
	"./pt-BR": 668,
	"./pt-BR/": 668,
	"./pt-BR/_lib/formatDistance": 527,
	"./pt-BR/_lib/formatDistance/": 527,
	"./pt-BR/_lib/formatDistance/index": 527,
	"./pt-BR/_lib/formatDistance/index.js": 527,
	"./pt-BR/_lib/formatLong": 528,
	"./pt-BR/_lib/formatLong/": 528,
	"./pt-BR/_lib/formatLong/index": 528,
	"./pt-BR/_lib/formatLong/index.js": 528,
	"./pt-BR/_lib/formatRelative": 529,
	"./pt-BR/_lib/formatRelative/": 529,
	"./pt-BR/_lib/formatRelative/index": 529,
	"./pt-BR/_lib/formatRelative/index.js": 529,
	"./pt-BR/_lib/localize": 530,
	"./pt-BR/_lib/localize/": 530,
	"./pt-BR/_lib/localize/index": 530,
	"./pt-BR/_lib/localize/index.js": 530,
	"./pt-BR/_lib/match": 531,
	"./pt-BR/_lib/match/": 531,
	"./pt-BR/_lib/match/index": 531,
	"./pt-BR/_lib/match/index.js": 531,
	"./pt-BR/index": 851,
	"./pt-BR/index.d.ts": 1191,
	"./pt-BR/index.js": 851,
	"./pt-BR/index.js.flow": 1192,
	"./pt-BR/package": 953,
	"./pt-BR/package.json": 953,
	"./pt/": 667,
	"./pt/_lib/formatDistance": 522,
	"./pt/_lib/formatDistance/": 522,
	"./pt/_lib/formatDistance/index": 522,
	"./pt/_lib/formatDistance/index.js": 522,
	"./pt/_lib/formatLong": 523,
	"./pt/_lib/formatLong/": 523,
	"./pt/_lib/formatLong/index": 523,
	"./pt/_lib/formatLong/index.js": 523,
	"./pt/_lib/formatRelative": 524,
	"./pt/_lib/formatRelative/": 524,
	"./pt/_lib/formatRelative/index": 524,
	"./pt/_lib/formatRelative/index.js": 524,
	"./pt/_lib/localize": 525,
	"./pt/_lib/localize/": 525,
	"./pt/_lib/localize/index": 525,
	"./pt/_lib/localize/index.js": 525,
	"./pt/_lib/match": 526,
	"./pt/_lib/match/": 526,
	"./pt/_lib/match/index": 526,
	"./pt/_lib/match/index.js": 526,
	"./pt/index": 850,
	"./pt/index.d.ts": 1193,
	"./pt/index.js": 850,
	"./pt/index.js.flow": 1194,
	"./pt/package": 954,
	"./pt/package.json": 954,
	"./ro": 669,
	"./ro/": 669,
	"./ro/_lib/formatDistance": 532,
	"./ro/_lib/formatDistance/": 532,
	"./ro/_lib/formatDistance/index": 532,
	"./ro/_lib/formatDistance/index.js": 532,
	"./ro/_lib/formatLong": 533,
	"./ro/_lib/formatLong/": 533,
	"./ro/_lib/formatLong/index": 533,
	"./ro/_lib/formatLong/index.js": 533,
	"./ro/_lib/formatRelative": 534,
	"./ro/_lib/formatRelative/": 534,
	"./ro/_lib/formatRelative/index": 534,
	"./ro/_lib/formatRelative/index.js": 534,
	"./ro/_lib/localize": 535,
	"./ro/_lib/localize/": 535,
	"./ro/_lib/localize/index": 535,
	"./ro/_lib/localize/index.js": 535,
	"./ro/_lib/match": 536,
	"./ro/_lib/match/": 536,
	"./ro/_lib/match/index": 536,
	"./ro/_lib/match/index.js": 536,
	"./ro/index": 852,
	"./ro/index.d.ts": 1195,
	"./ro/index.js": 852,
	"./ro/index.js.flow": 1196,
	"./ro/package": 955,
	"./ro/package.json": 955,
	"./ru": 670,
	"./ru/": 670,
	"./ru/_lib/formatDistance": 537,
	"./ru/_lib/formatDistance/": 537,
	"./ru/_lib/formatDistance/index": 537,
	"./ru/_lib/formatDistance/index.js": 537,
	"./ru/_lib/formatLong": 538,
	"./ru/_lib/formatLong/": 538,
	"./ru/_lib/formatLong/index": 538,
	"./ru/_lib/formatLong/index.js": 538,
	"./ru/_lib/formatRelative": 539,
	"./ru/_lib/formatRelative/": 539,
	"./ru/_lib/formatRelative/index": 539,
	"./ru/_lib/formatRelative/index.js": 539,
	"./ru/_lib/localize": 540,
	"./ru/_lib/localize/": 540,
	"./ru/_lib/localize/index": 540,
	"./ru/_lib/localize/index.js": 540,
	"./ru/_lib/match": 541,
	"./ru/_lib/match/": 541,
	"./ru/_lib/match/index": 541,
	"./ru/_lib/match/index.js": 541,
	"./ru/index": 853,
	"./ru/index.d.ts": 1197,
	"./ru/index.js": 853,
	"./ru/index.js.flow": 1198,
	"./ru/package": 956,
	"./ru/package.json": 956,
	"./sk": 671,
	"./sk/": 671,
	"./sk/_lib/formatDistance": 542,
	"./sk/_lib/formatDistance/": 542,
	"./sk/_lib/formatDistance/index": 542,
	"./sk/_lib/formatDistance/index.js": 542,
	"./sk/_lib/formatLong": 543,
	"./sk/_lib/formatLong/": 543,
	"./sk/_lib/formatLong/index": 543,
	"./sk/_lib/formatLong/index.js": 543,
	"./sk/_lib/formatRelative": 544,
	"./sk/_lib/formatRelative/": 544,
	"./sk/_lib/formatRelative/index": 544,
	"./sk/_lib/formatRelative/index.js": 544,
	"./sk/_lib/localize": 545,
	"./sk/_lib/localize/": 545,
	"./sk/_lib/localize/index": 545,
	"./sk/_lib/localize/index.js": 545,
	"./sk/_lib/match": 546,
	"./sk/_lib/match/": 546,
	"./sk/_lib/match/index": 546,
	"./sk/_lib/match/index.js": 546,
	"./sk/index": 854,
	"./sk/index.d.ts": 1199,
	"./sk/index.js": 854,
	"./sk/index.js.flow": 1200,
	"./sk/package": 957,
	"./sk/package.json": 957,
	"./sl": 672,
	"./sl/": 672,
	"./sl/_lib/formatDistance": 547,
	"./sl/_lib/formatDistance/": 547,
	"./sl/_lib/formatDistance/index": 547,
	"./sl/_lib/formatDistance/index.js": 547,
	"./sl/_lib/formatLong": 548,
	"./sl/_lib/formatLong/": 548,
	"./sl/_lib/formatLong/index": 548,
	"./sl/_lib/formatLong/index.js": 548,
	"./sl/_lib/formatRelative": 549,
	"./sl/_lib/formatRelative/": 549,
	"./sl/_lib/formatRelative/index": 549,
	"./sl/_lib/formatRelative/index.js": 549,
	"./sl/_lib/localize": 550,
	"./sl/_lib/localize/": 550,
	"./sl/_lib/localize/index": 550,
	"./sl/_lib/localize/index.js": 550,
	"./sl/_lib/match": 551,
	"./sl/_lib/match/": 551,
	"./sl/_lib/match/index": 551,
	"./sl/_lib/match/index.js": 551,
	"./sl/index": 855,
	"./sl/index.d.ts": 1201,
	"./sl/index.js": 855,
	"./sl/index.js.flow": 1202,
	"./sl/package": 958,
	"./sl/package.json": 958,
	"./sr": 673,
	"./sr-Latn": 674,
	"./sr-Latn/": 674,
	"./sr-Latn/_lib/formatDistance": 557,
	"./sr-Latn/_lib/formatDistance/": 557,
	"./sr-Latn/_lib/formatDistance/index": 557,
	"./sr-Latn/_lib/formatDistance/index.js": 557,
	"./sr-Latn/_lib/formatLong": 558,
	"./sr-Latn/_lib/formatLong/": 558,
	"./sr-Latn/_lib/formatLong/index": 558,
	"./sr-Latn/_lib/formatLong/index.js": 558,
	"./sr-Latn/_lib/formatRelative": 559,
	"./sr-Latn/_lib/formatRelative/": 559,
	"./sr-Latn/_lib/formatRelative/index": 559,
	"./sr-Latn/_lib/formatRelative/index.js": 559,
	"./sr-Latn/_lib/localize": 560,
	"./sr-Latn/_lib/localize/": 560,
	"./sr-Latn/_lib/localize/index": 560,
	"./sr-Latn/_lib/localize/index.js": 560,
	"./sr-Latn/_lib/match": 561,
	"./sr-Latn/_lib/match/": 561,
	"./sr-Latn/_lib/match/index": 561,
	"./sr-Latn/_lib/match/index.js": 561,
	"./sr-Latn/index": 857,
	"./sr-Latn/index.d.ts": 1203,
	"./sr-Latn/index.js": 857,
	"./sr-Latn/index.js.flow": 1204,
	"./sr-Latn/package": 959,
	"./sr-Latn/package.json": 959,
	"./sr/": 673,
	"./sr/_lib/formatDistance": 552,
	"./sr/_lib/formatDistance/": 552,
	"./sr/_lib/formatDistance/index": 552,
	"./sr/_lib/formatDistance/index.js": 552,
	"./sr/_lib/formatLong": 553,
	"./sr/_lib/formatLong/": 553,
	"./sr/_lib/formatLong/index": 553,
	"./sr/_lib/formatLong/index.js": 553,
	"./sr/_lib/formatRelative": 554,
	"./sr/_lib/formatRelative/": 554,
	"./sr/_lib/formatRelative/index": 554,
	"./sr/_lib/formatRelative/index.js": 554,
	"./sr/_lib/localize": 555,
	"./sr/_lib/localize/": 555,
	"./sr/_lib/localize/index": 555,
	"./sr/_lib/localize/index.js": 555,
	"./sr/_lib/match": 556,
	"./sr/_lib/match/": 556,
	"./sr/_lib/match/index": 556,
	"./sr/_lib/match/index.js": 556,
	"./sr/index": 856,
	"./sr/index.d.ts": 1205,
	"./sr/index.js": 856,
	"./sr/index.js.flow": 1206,
	"./sr/package": 960,
	"./sr/package.json": 960,
	"./sv": 675,
	"./sv/": 675,
	"./sv/_lib/formatDistance": 562,
	"./sv/_lib/formatDistance/": 562,
	"./sv/_lib/formatDistance/index": 562,
	"./sv/_lib/formatDistance/index.js": 562,
	"./sv/_lib/formatLong": 563,
	"./sv/_lib/formatLong/": 563,
	"./sv/_lib/formatLong/index": 563,
	"./sv/_lib/formatLong/index.js": 563,
	"./sv/_lib/formatRelative": 564,
	"./sv/_lib/formatRelative/": 564,
	"./sv/_lib/formatRelative/index": 564,
	"./sv/_lib/formatRelative/index.js": 564,
	"./sv/_lib/localize": 565,
	"./sv/_lib/localize/": 565,
	"./sv/_lib/localize/index": 565,
	"./sv/_lib/localize/index.js": 565,
	"./sv/_lib/match": 566,
	"./sv/_lib/match/": 566,
	"./sv/_lib/match/index": 566,
	"./sv/_lib/match/index.js": 566,
	"./sv/index": 858,
	"./sv/index.d.ts": 1207,
	"./sv/index.js": 858,
	"./sv/index.js.flow": 1208,
	"./sv/package": 961,
	"./sv/package.json": 961,
	"./ta": 676,
	"./ta/": 676,
	"./ta/_lib/formatDistance": 567,
	"./ta/_lib/formatDistance/": 567,
	"./ta/_lib/formatDistance/index": 567,
	"./ta/_lib/formatDistance/index.js": 567,
	"./ta/_lib/formatLong": 568,
	"./ta/_lib/formatLong/": 568,
	"./ta/_lib/formatLong/index": 568,
	"./ta/_lib/formatLong/index.js": 568,
	"./ta/_lib/formatRelative": 569,
	"./ta/_lib/formatRelative/": 569,
	"./ta/_lib/formatRelative/index": 569,
	"./ta/_lib/formatRelative/index.js": 569,
	"./ta/_lib/localize": 570,
	"./ta/_lib/localize/": 570,
	"./ta/_lib/localize/index": 570,
	"./ta/_lib/localize/index.js": 570,
	"./ta/_lib/match": 571,
	"./ta/_lib/match/": 571,
	"./ta/_lib/match/index": 571,
	"./ta/_lib/match/index.js": 571,
	"./ta/index": 859,
	"./ta/index.d.ts": 1209,
	"./ta/index.js": 859,
	"./ta/index.js.flow": 1210,
	"./ta/package": 962,
	"./ta/package.json": 962,
	"./te": 677,
	"./te/": 677,
	"./te/_lib/formatDistance": 572,
	"./te/_lib/formatDistance/": 572,
	"./te/_lib/formatDistance/index": 572,
	"./te/_lib/formatDistance/index.js": 572,
	"./te/_lib/formatLong": 573,
	"./te/_lib/formatLong/": 573,
	"./te/_lib/formatLong/index": 573,
	"./te/_lib/formatLong/index.js": 573,
	"./te/_lib/formatRelative": 574,
	"./te/_lib/formatRelative/": 574,
	"./te/_lib/formatRelative/index": 574,
	"./te/_lib/formatRelative/index.js": 574,
	"./te/_lib/localize": 575,
	"./te/_lib/localize/": 575,
	"./te/_lib/localize/index": 575,
	"./te/_lib/localize/index.js": 575,
	"./te/_lib/match": 576,
	"./te/_lib/match/": 576,
	"./te/_lib/match/index": 576,
	"./te/_lib/match/index.js": 576,
	"./te/index": 860,
	"./te/index.d.ts": 1211,
	"./te/index.js": 860,
	"./te/index.js.flow": 1212,
	"./te/package": 963,
	"./te/package.json": 963,
	"./th": 678,
	"./th/": 678,
	"./th/_lib/formatDistance": 577,
	"./th/_lib/formatDistance/": 577,
	"./th/_lib/formatDistance/index": 577,
	"./th/_lib/formatDistance/index.js": 577,
	"./th/_lib/formatLong": 578,
	"./th/_lib/formatLong/": 578,
	"./th/_lib/formatLong/index": 578,
	"./th/_lib/formatLong/index.js": 578,
	"./th/_lib/formatRelative": 579,
	"./th/_lib/formatRelative/": 579,
	"./th/_lib/formatRelative/index": 579,
	"./th/_lib/formatRelative/index.js": 579,
	"./th/_lib/localize": 580,
	"./th/_lib/localize/": 580,
	"./th/_lib/localize/index": 580,
	"./th/_lib/localize/index.js": 580,
	"./th/_lib/match": 581,
	"./th/_lib/match/": 581,
	"./th/_lib/match/index": 581,
	"./th/_lib/match/index.js": 581,
	"./th/index": 861,
	"./th/index.d.ts": 1213,
	"./th/index.js": 861,
	"./th/index.js.flow": 1214,
	"./th/package": 964,
	"./th/package.json": 964,
	"./tr": 679,
	"./tr/": 679,
	"./tr/_lib/formatDistance": 582,
	"./tr/_lib/formatDistance/": 582,
	"./tr/_lib/formatDistance/index": 582,
	"./tr/_lib/formatDistance/index.js": 582,
	"./tr/_lib/formatLong": 583,
	"./tr/_lib/formatLong/": 583,
	"./tr/_lib/formatLong/index": 583,
	"./tr/_lib/formatLong/index.js": 583,
	"./tr/_lib/formatRelative": 584,
	"./tr/_lib/formatRelative/": 584,
	"./tr/_lib/formatRelative/index": 584,
	"./tr/_lib/formatRelative/index.js": 584,
	"./tr/_lib/localize": 585,
	"./tr/_lib/localize/": 585,
	"./tr/_lib/localize/index": 585,
	"./tr/_lib/localize/index.js": 585,
	"./tr/_lib/match": 586,
	"./tr/_lib/match/": 586,
	"./tr/_lib/match/index": 586,
	"./tr/_lib/match/index.js": 586,
	"./tr/index": 862,
	"./tr/index.d.ts": 1215,
	"./tr/index.js": 862,
	"./tr/index.js.flow": 1216,
	"./tr/package": 965,
	"./tr/package.json": 965,
	"./ug": 680,
	"./ug/": 680,
	"./ug/_lib/formatDistance": 587,
	"./ug/_lib/formatDistance/": 587,
	"./ug/_lib/formatDistance/index": 587,
	"./ug/_lib/formatDistance/index.js": 587,
	"./ug/_lib/formatLong": 588,
	"./ug/_lib/formatLong/": 588,
	"./ug/_lib/formatLong/index": 588,
	"./ug/_lib/formatLong/index.js": 588,
	"./ug/_lib/formatRelative": 589,
	"./ug/_lib/formatRelative/": 589,
	"./ug/_lib/formatRelative/index": 589,
	"./ug/_lib/formatRelative/index.js": 589,
	"./ug/_lib/localize": 590,
	"./ug/_lib/localize/": 590,
	"./ug/_lib/localize/index": 590,
	"./ug/_lib/localize/index.js": 590,
	"./ug/_lib/match": 591,
	"./ug/_lib/match/": 591,
	"./ug/_lib/match/index": 591,
	"./ug/_lib/match/index.js": 591,
	"./ug/index": 863,
	"./ug/index.d.ts": 1217,
	"./ug/index.js": 863,
	"./ug/index.js.flow": 1218,
	"./ug/package": 966,
	"./ug/package.json": 966,
	"./uk": 681,
	"./uk/": 681,
	"./uk/_lib/formatDistance": 592,
	"./uk/_lib/formatDistance/": 592,
	"./uk/_lib/formatDistance/index": 592,
	"./uk/_lib/formatDistance/index.js": 592,
	"./uk/_lib/formatLong": 593,
	"./uk/_lib/formatLong/": 593,
	"./uk/_lib/formatLong/index": 593,
	"./uk/_lib/formatLong/index.js": 593,
	"./uk/_lib/formatRelative": 594,
	"./uk/_lib/formatRelative/": 594,
	"./uk/_lib/formatRelative/index": 594,
	"./uk/_lib/formatRelative/index.js": 594,
	"./uk/_lib/localize": 595,
	"./uk/_lib/localize/": 595,
	"./uk/_lib/localize/index": 595,
	"./uk/_lib/localize/index.js": 595,
	"./uk/_lib/match": 596,
	"./uk/_lib/match/": 596,
	"./uk/_lib/match/index": 596,
	"./uk/_lib/match/index.js": 596,
	"./uk/index": 864,
	"./uk/index.d.ts": 1219,
	"./uk/index.js": 864,
	"./uk/index.js.flow": 1220,
	"./uk/package": 967,
	"./uk/package.json": 967,
	"./uz": 682,
	"./uz/": 682,
	"./uz/_lib/formatDistance": 597,
	"./uz/_lib/formatDistance/": 597,
	"./uz/_lib/formatDistance/index": 597,
	"./uz/_lib/formatDistance/index.js": 597,
	"./uz/_lib/formatLong": 598,
	"./uz/_lib/formatLong/": 598,
	"./uz/_lib/formatLong/index": 598,
	"./uz/_lib/formatLong/index.js": 598,
	"./uz/_lib/formatRelative": 599,
	"./uz/_lib/formatRelative/": 599,
	"./uz/_lib/formatRelative/index": 599,
	"./uz/_lib/formatRelative/index.js": 599,
	"./uz/_lib/localize": 600,
	"./uz/_lib/localize/": 600,
	"./uz/_lib/localize/index": 600,
	"./uz/_lib/localize/index.js": 600,
	"./uz/_lib/match": 601,
	"./uz/_lib/match/": 601,
	"./uz/_lib/match/index": 601,
	"./uz/_lib/match/index.js": 601,
	"./uz/index": 865,
	"./uz/index.d.ts": 1221,
	"./uz/index.js": 865,
	"./uz/index.js.flow": 1222,
	"./uz/package": 968,
	"./uz/package.json": 968,
	"./vi": 683,
	"./vi/": 683,
	"./vi/_lib/formatDistance": 602,
	"./vi/_lib/formatDistance/": 602,
	"./vi/_lib/formatDistance/index": 602,
	"./vi/_lib/formatDistance/index.js": 602,
	"./vi/_lib/formatLong": 603,
	"./vi/_lib/formatLong/": 603,
	"./vi/_lib/formatLong/index": 603,
	"./vi/_lib/formatLong/index.js": 603,
	"./vi/_lib/formatRelative": 604,
	"./vi/_lib/formatRelative/": 604,
	"./vi/_lib/formatRelative/index": 604,
	"./vi/_lib/formatRelative/index.js": 604,
	"./vi/_lib/localize": 605,
	"./vi/_lib/localize/": 605,
	"./vi/_lib/localize/index": 605,
	"./vi/_lib/localize/index.js": 605,
	"./vi/_lib/match": 606,
	"./vi/_lib/match/": 606,
	"./vi/_lib/match/index": 606,
	"./vi/_lib/match/index.js": 606,
	"./vi/index": 866,
	"./vi/index.d.ts": 1223,
	"./vi/index.js": 866,
	"./vi/index.js.flow": 1224,
	"./vi/package": 969,
	"./vi/package.json": 969,
	"./zh-CN": 684,
	"./zh-CN/": 684,
	"./zh-CN/_lib/formatDistance": 607,
	"./zh-CN/_lib/formatDistance/": 607,
	"./zh-CN/_lib/formatDistance/index": 607,
	"./zh-CN/_lib/formatDistance/index.js": 607,
	"./zh-CN/_lib/formatLong": 608,
	"./zh-CN/_lib/formatLong/": 608,
	"./zh-CN/_lib/formatLong/index": 608,
	"./zh-CN/_lib/formatLong/index.js": 608,
	"./zh-CN/_lib/formatRelative": 609,
	"./zh-CN/_lib/formatRelative/": 609,
	"./zh-CN/_lib/formatRelative/index": 609,
	"./zh-CN/_lib/formatRelative/index.js": 609,
	"./zh-CN/_lib/localize": 610,
	"./zh-CN/_lib/localize/": 610,
	"./zh-CN/_lib/localize/index": 610,
	"./zh-CN/_lib/localize/index.js": 610,
	"./zh-CN/_lib/match": 611,
	"./zh-CN/_lib/match/": 611,
	"./zh-CN/_lib/match/index": 611,
	"./zh-CN/_lib/match/index.js": 611,
	"./zh-CN/index": 867,
	"./zh-CN/index.d.ts": 1225,
	"./zh-CN/index.js": 867,
	"./zh-CN/index.js.flow": 1226,
	"./zh-CN/package": 970,
	"./zh-CN/package.json": 970,
	"./zh-TW": 685,
	"./zh-TW/": 685,
	"./zh-TW/_lib/formatDistance": 612,
	"./zh-TW/_lib/formatDistance/": 612,
	"./zh-TW/_lib/formatDistance/index": 612,
	"./zh-TW/_lib/formatDistance/index.js": 612,
	"./zh-TW/_lib/formatLong": 613,
	"./zh-TW/_lib/formatLong/": 613,
	"./zh-TW/_lib/formatLong/index": 613,
	"./zh-TW/_lib/formatLong/index.js": 613,
	"./zh-TW/_lib/formatRelative": 614,
	"./zh-TW/_lib/formatRelative/": 614,
	"./zh-TW/_lib/formatRelative/index": 614,
	"./zh-TW/_lib/formatRelative/index.js": 614,
	"./zh-TW/_lib/localize": 615,
	"./zh-TW/_lib/localize/": 615,
	"./zh-TW/_lib/localize/index": 615,
	"./zh-TW/_lib/localize/index.js": 615,
	"./zh-TW/_lib/match": 616,
	"./zh-TW/_lib/match/": 616,
	"./zh-TW/_lib/match/index": 616,
	"./zh-TW/_lib/match/index.js": 616,
	"./zh-TW/index": 868,
	"./zh-TW/index.d.ts": 1227,
	"./zh-TW/index.js": 868,
	"./zh-TW/index.js.flow": 1228,
	"./zh-TW/package": 971,
	"./zh-TW/package.json": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1077;